<template #customActions>
  <div class="d-flex">
    <action-button
      i="fas fa-arrow-circle-left"
      text="Regresar"
      variant="outline-success"
      @click="$router.go(-1)"
    />
    <div class="dropdown d-flex ml-0 ml-md-3 btn-block-xs-only">
      <action-button
        id="action-dropdown"
        aria-expanded="false"
        aria-haspopup="true"
        class="pt-1 success outline-success"
        data-toggle="dropdown"
        type="button"
      >
        <i class="fas fa-folders mt-1" />
        <span class="px-2">Informes</span>
        <i class="fa fa-angle-down" />
      </action-button>
      <div
        aria-labelledby="action-dropdown"
        class="dropdown-menu dropdown-menu-right"
      >
        <div
          class="dropdown-item cursor-pointer border-bottom mb-2 pb-2"
          @click="() => this.$emit('on-download-dans-excel-report')"
        >
          <em class="fas fa-print pr-3 text-green" />
          <span class="color-black font-15 font-weight-normal">
            Archivos DANS (Excel)
          </span>
        </div>
        <div
          class="dropdown-item cursor-pointer border-bottom mb-2 pb-2"
          @click="() => this.$emit('on-download-dans-word-report')"
        >
          <em class="fas fa-print pr-3 text-green" />
          <span class="color-black font-15 font-weight-normal">
            Archivos DANS (Word)
          </span>
        </div>

        <div
          class="dropdown-item cursor-pointer"
          @click="() => this.$emit('on-download-details-report')"
        >
          <em class="fas fa-print pr-3 text-green" />
          <span class="color-black font-15 font-weight-normal">
            Detalle de Datos
          </span>
        </div>
      </div>
    </div>
    <action-button
      i="fas fa-undo"
      text="Actualizar"
      variant="outline-success ml-3"
      v-if="statusId == edenStatus.NEW"
      @click="() => this.$emit('on-update')"
    />
    <action-button
      i="fas fa-flag"
      text="Generar Archivos"
      variant="success ml-3 d-none d-md-block"
      v-if="statusId == edenStatus.NEW"
      @click="() => this.$emit('on-generate-files')"
    />
    <action-button
      i="fas fa-flag"
      text="Generar"
      v-if="statusId == edenStatus.NEW"
      variant="success ml-3 d-md-none d-xs-block"
      @click="() => this.$emit('on-generate')"
    />
    <action-button
      i="far fa-minus-circle pr-2"
      text="Eliminar Archivos"
      variant="outline-danger ml-3  d-none d-md-block"
      v-if="statusId == edenStatus.GENERATED_FILE && deleteSubmitActionsVisible"
      @click="() => this.$emit('on-delete-files')"
    />
    <action-button
      i="far fa-minus-circle pr-2"
      text="Eliminar"
      variant="outline-danger ml-3 d-md-none d-xs-block"
      v-if="statusId == edenStatus.GENERATED_FILE && deleteSubmitActionsVisible"
      @click="() => this.$emit('on-delete-files')"
    />
    <action-button
      i="fas fa-flag"
      text="Someter"
      variant="success ml-3"
      v-if="statusId == edenStatus.GENERATED_FILE && deleteSubmitActionsVisible"
      @click="() => this.$emit('on-submit')"
    />
  </div>
</template>

<script>
import ActionButton from 'ActionButton'
import edenStatus from '@/utils/constants/edenStatus.js'

export default {
  name: 'DetailHeaderButtons',
  components: {
    ActionButton,
  },
  props: {
    statusId: {
      type: Number,
      default: () => 0,
    },
    deleteSubmitActionsVisible: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      edenStatus,
    }
  },
}
</script>

<style lang="scss">
.page-header__extended ::v-deep {
  @media (max-width: 575px) {
    .mobile-actions {
      display: flex;
      flex-direction: column;
    }
  }
}
@media (max-width: 425px) {
  .execute-button {
    text-align: center !important;
  }
  .mobile-actions {
    margin-left: 5px !important;
    .ab-btn {
      font-size: 12px !important;
      padding-top: 8px !important;
      padding-bottom: 8px !important;
      i {
        margin: 0 !important;
      }
    }
    #action-dropdown {
      i:nth-child(3) {
        display: none;
      }
      span {
        padding-left: 1px !important;
        padding-right: 0px !important;
      }
    }
  }
}
</style>
